'use client';

import { useRef } from 'react';
import type { ReactNode } from 'react';
import GridClearing from '@/components/GridClearing';

/** Content column on the body grid (container − 1 cell, half a cell inside
 *  the rails) with whole-cell clearings behind every [data-grid-block]. */
export default function StatusShell({ className = '', children }: { className?: string; children: ReactNode }) {
  const rootRef = useRef<HTMLDivElement>(null);
  return (
    <section className={`relative pb-20 md:pb-[var(--grid-cell,72px)] ${className}`}>
      <div
        ref={rootRef}
        className="relative mx-auto w-full max-w-[1200px] px-7 md:w-[calc(var(--grid-container-width,1224px)_-_var(--grid-cell,72px))] md:max-w-full md:px-0"
      >
        <GridClearing rootRef={rootRef} />
        <div className="relative z-10 flex flex-col">{children}</div>
      </div>
    </section>
  );
}
